<template>
    <a class="header__account-item header__account--favorite" :href="link">
        <span v-if="count > 0">{{ count }}</span>
    </a>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name    : "MiniFavs",
    props: ['link'],
    computed: {
        ... mapState([
            'moduleFavorites'
        ]),
        count() {
            if(this.moduleFavorites.favorites)
                return this.moduleFavorites.favorites.length;
            else
                return 0;
        },
    },
    methods : {
        ... mapActions([
            'GET_FAVS'
        ]),
    },
    created() {
        if(this.moduleFavorites.favorites.length > 0) return;
        this.GET_FAVS();
    }
}
</script>

<style scoped>

</style>